module.exports = __webpack_public_path__ + "static/media/view-alt-svgrepo-com.cca08626.svg";